import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class OrganizationType extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline;
        overflow: hidden;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html`<bn-placeholder inline></bn-placeholder>`;
    }
    const orgType = this.entity.getSubEntity('https://api.binsentry.com/rel/organization-type');
    return html`
      <span title="${orgType.properties.description}">
        ${orgType.properties.displayName}
      </span>
    `;
  }
}

window.customElements.define('organization-type', OrganizationType);
